<script setup lang="ts">
import Tooltip from "~/components/Common/Tooltip.vue";

defineProps<{
  label?: string;
  required?: boolean;
  error?: string | null;
  labelClass?: string;
  tooltip?: string;
  tooltipPosition?: string;
}>();
</script>

<template>
  <div class="flex flex-col gap-[8px] w-full">
    <slot name="label">
      <template v-if="label">
        <div v-if="tooltip" class="flex items-center">
          <label :class="labelClass ?? 'body_regular text-secondary-color'">{{ label }}<span v-if="required">*</span></label>
          <Tooltip :position="tooltipPosition ?? 'bot-right'" class="ml-1">
            <template #content>
              <div class="flex w-[300px] gap-[8px]">
                <img src="/icons/emojis/eyes.svg" alt="" class="h-4 w-4" />
                <span>{{ tooltip }}</span>
              </div>
            </template>
          </Tooltip>
        </div>
        <label v-else :class="labelClass ?? 'body_regular text-secondary-color'">{{ label }}<span v-if="required">*</span></label>
      </template>
    </slot>
    <slot :invalid="!!error" />
    <span v-if="error" class="small_regular text-primary-red-color mt-[4px]">
      {{ error }}
    </span>
  </div>
</template>
